import type { AvailableGameCatalogEntry } from '../../catalog-entry.js';
import { heartsDescriptor } from './descriptor.js';

export const heartsCatalogEntry = {
  descriptor: heartsDescriptor,
  availability: 'production',
  load: async () => (await import('./game.js')).heartsGeneratorDefinition,
} satisfies AvailableGameCatalogEntry;
